import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
var Loading = /*#__PURE__*/function (_React$Component) {
  _inherits(Loading, _React$Component);
  var _super = _createSuper(Loading);
  function Loading() {
    _classCallCheck(this, Loading);
    return _super.apply(this, arguments);
  }
  _createClass(Loading, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "empty-loading-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "lds-ripple page-centered"
      }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null)));
    }
  }]);
  return Loading;
}(React.Component);
export default Loading;